module.exports = __webpack_public_path__ + "img/how-it-works-5.977d77a7.svg";